var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSchool = function SvgSchool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10 2.5-9.167 5 3.334 1.817v5L10 17.5l5.833-3.183v-5l1.667-.909v5.759h1.667V7.5zm5.683 5L10 10.6 4.317 7.5 10 4.4zm-1.516 5.825L10 15.6l-4.167-2.275v-3.1L10 12.5l4.167-2.275z"
  })));
};
export default SvgSchool;